import { render, staticRenderFns } from "./popular-search-add.vue?vue&type=template&id=0d5e8d81&"
import script from "./popular-search-add.vue?vue&type=script&lang=js&"
export * from "./popular-search-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports